(function () {
    function syncDetails(): void {
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        document.querySelectorAll<HTMLDetailsElement>(".kiv-block details").forEach(function (d) {
            if (isMobile) {
                d.setAttribute("open", "");
            } else {
                d.removeAttribute("open");
            }
        });
    }
    syncDetails();
    window.addEventListener("resize", syncDetails);
})();